import { render } from "./ScreeningSection.vue?vue&type=template&id=521bd0a3&scoped=true"
import script from "./ScreeningSection.vue?vue&type=script&lang=js"
export * from "./ScreeningSection.vue?vue&type=script&lang=js"

import "./ScreeningSection.vue?vue&type=style&index=0&id=521bd0a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521bd0a3"]])

export default __exports__